// extracted by mini-css-extract-plugin
export default {"statTitle":"ShortFootball_statTitle--_eD","stat":"ShortFootball_stat--TAr","container":"ShortFootball_container--Ok6"};